import { createContext, useContext, useState, useEffect, ReactNode } from 'react'

interface AuthContextType {
  token: string
  isLoggedIn: boolean
  setToken: (t: string) => void
  logout: () => void
}

export const AuthContext = createContext<AuthContextType>({
  token: '',
  isLoggedIn: false,
  setToken: () => {},
  logout: () => {},
})

export function AuthProvider({ children }: { children: ReactNode }) {
  const [token, setTokenState] = useState(() => localStorage.getItem('missao_token') || '')

  const isLoggedIn = Boolean(token)

  function setToken(t: string) {
    localStorage.setItem('missao_token', t)
    setTokenState(t)
  }

  function logout() {
    localStorage.removeItem('missao_token')
    setTokenState('')
  }

  return (
    <AuthContext.Provider value={{ token, isLoggedIn, setToken, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}
